/**************************************************
 * Nombre:       Seccion_Resultados
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import Tarjeta_Resultados from "../Tarjetas/Tarjeta_Resultados";
import {buscarPalabra} from "../../Modulo_Algolia/Funciones/buscarPalabra";
import {usuarioContext} from "../../App";


const Seccion_Resultados = () => {
    const cData = useContext(usuarioContext)
    const parms = useParams()
    const [palabra, setPalabra] = useState('')
    const [resultados, setResultados] = useState([])

    const buscar = async (palabra) => {

        setResultados([])

        let res = await buscarPalabra({palabra: palabra, coleccion: 'general'})
        if (res) {

            let arr = []

            for (let i = 0; i < res.length; i++) {
                 let resul = res[i]
                if (resul.paises) {

                    if (resul.paises.includes(cData.usuario.pais)) {
                        arr.push(resul)
                    }

                }else{
                    arr.push(resul)
                }
            }

            setResultados(arr)
        }

    }

    useEffect(() => {

        if (parms && parms.id) {
            setPalabra(parms.id)
            buscar(parms.id).then()
        }

    }, [parms]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={0}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 2}}>
                    <Typography sx={{fontSize: 16, fontWeight: 400}}>Resultados de:</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: -0.5}}>
                    <Typography sx={{fontSize: 24, fontWeight: 600}}>{palabra}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start', mt: 4}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={4}
                    >

                        {resultados.map((it) => {
                            return (
                                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjeta_Resultados item={it}/>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Resultados



